<div class="flex flex-shrink-0 flex-col" #bannersContainer *ngIf="env.SHOW_BANNERS && (banners$ | async)?.length">
    <rwidget-banner *ngFor="let banner of banners$ | async" [bannerMessage]="banner"></rwidget-banner>
</div>
<div class="tickets-content var-app-light:bg-grey-white_smoke flex-column flex min-h-0 flex-1 md:p-4">
    <div class="flex min-h-0 w-full flex-col md:mx-auto md:max-w-[62rem]">
        <rwidget-alert class="flex-shrink-0"></rwidget-alert>

        <div class="flex min-h-0 flex-col md:flex-row md:gap-8">
            <div
                class="relative h-16 w-full md:w-64 md:flex-shrink-0"
                [ngClass]="
                    env.APP_NAME === 'gotland' ? ['bg-primary dark:bg-contrast-black', 'md:bg-white'] : 'bg-white'
                ">
                <h1
                    class="vl-app-light:font-bold var-app-light-dark:font-bold var-app-light:text-black flex h-full items-center justify-center text-center text-base font-semibold md:justify-start md:text-5xl md:font-normal">
                    {{ 'FOOTER_TICKETS' | translate }}
                </h1>
                <button
                    class="absolute right-[15px] top-0 flex h-full items-center justify-center px-4 md:hidden"
                    *ngIf="isWebPurchaseAllowed && (isOnline$ | async) === true"
                    [attr.aria-label]="'BTN_BUY_TICKET' | translate"
                    (click)="purchaseTicket()">
                    <ion-icon
                        class="filter-secondary text-xl dark:filter-yellow"
                        [attr.src]="(assetsPath$ | async) + '/img/plus.svg'"
                        aria-hidden="true">
                    </ion-icon>
                </button>
                <ion-button
                    class="mt-4 hidden w-full md:block"
                    *ngIf="isWebPurchaseAllowed"
                    [attr.aria-label]="'BTN_BUY_TICKET' | translate"
                    (click)="purchaseTicket()"
                    size="large"
                    color="{{ env.TICKET?.BUY_TICKET_BUTTON_COLOR_SCHEME ?? 'secondary' }}">
                    <ion-label class="text-base font-bold normal-case">
                        {{ 'BTN_BUY_TICKET' | translate }}
                    </ion-label>
                </ion-button>
                <div *ngIf="isInLandscapeMode && isFavouritesTab()">
                    <ridango-ui-alert type="grey-info">
                        <div class="vl-app-light-dark:hidden">
                            {{ 'FAVORITE_TICKETS_INFO' | translate }}
                        </div>
                    </ridango-ui-alert>
                </div>
            </div>

            <div class="min-h-0 min-w-0 flex-1">
                <mat-tab-group
                    class="ticket-tabs flex h-full flex-col text-base"
                    #tabGroup
                    [(selectedIndex)]="currentTabIndex"
                    [dynamicHeight]="true"
                    [ngClass]="{ 'ticket-tabs-colored': env.APP_NAME === 'gotland' }"
                    [disablePagination]="disablePagination"
                    (selectedIndexChange)="onSelectedIndexChange()"
                    color="none"
                    animationDuration="0ms">
                    <mat-tab [aria-label]="getAriaLabel(0, 'TICKETS_TAB_VALID' | translate)">
                        <ng-template matTabLabel>
                            <div
                                class="text-sm font-semibold uppercase leading-4"
                                [class.normal-case]="env.REMOVE_UPPERCASE">
                                {{ 'TICKETS_TAB_VALID' | translate }}
                            </div>
                        </ng-template>
                        <ng-template matTabContent>
                            <rwidget-ticket-card-container
                                class="my-4 block md:my-0 md:w-full md:rounded-lg md:bg-[#F0F0F0] md:p-4 dark:md:bg-contrast-black"></rwidget-ticket-card-container>
                        </ng-template>
                    </mat-tab>
                    <mat-tab
                        *ngIf="
                            env.SHOW_FAVORITE_TICKETS && this.favoriteTickets?.length && (isOnline$ | async) === true
                        "
                        [aria-label]="getAriaLabel(1, 'TICKETS_TAB_FAVORITES' | translate)"
                        [attr.aria-selected]="false">
                        <ng-template matTabLabel>
                            <div
                                class="text-sm font-semibold uppercase leading-4"
                                [class.normal-case]="env.REMOVE_UPPERCASE">
                                {{ 'TICKETS_TAB_FAVORITES' | translate }}
                            </div>
                        </ng-template>
                        <ng-template matTabContent>
                            <div class="mt-4">
                                <gl-purchase-v2-favorite-tickets
                                    [favoriteTickets]="favoriteTickets"></gl-purchase-v2-favorite-tickets>
                            </div>
                        </ng-template>
                    </mat-tab>
                    <mat-tab
                        *ngIf="env.SHOW_TICKET_HISTORY && (isOnline$ | async) === true"
                        [aria-label]="getAriaLabel(favoriteTickets?.length ? 2 : 1, 'TICKETS_TAB_HISTORY' | translate)">
                        <ng-template matTabLabel>
                            <div
                                class="text-sm font-semibold uppercase leading-4"
                                [class.normal-case]="env.REMOVE_UPPERCASE">
                                {{ 'TICKETS_TAB_HISTORY' | translate }}
                            </div>
                        </ng-template>
                        <ng-template matTabContent>
                            <rwidget-history-ticket-card-container></rwidget-history-ticket-card-container>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>

    <div
        class="var-app-light-dark:p-4 var-app-light:bg-grey-white_smoke mt-auto flex-shrink-0 px-4 pb-4 pt-2 dark:bg-contrast-black md:hidden">
        <button
            class="orb-app-light:bg-[var(--btn-primary-color)] orb-app-light:text-black pn-app-light:text-white pn-app-light:bg-primary pn-light:text-white pn-light:bg-primary gl-light:text-[var(--color-primary)] vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black var-app-light:text-contrast-black flex h-8 w-full items-center justify-center rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
            *ngIf="isWebPurchaseAllowed"
            [ngClass]="{
                'opacity-50': (isOnline$ | async) === false,
                'h-8': (isInLandscapeMode | async) === true,
                'h-14': (isInLandscapeMode | async) === false
            }"
            [disabled]="(isOnline$ | async) === false"
            [attr.aria-label]="'BTN_BUY_TICKET' | translate"
            (click)="purchaseTicket()">
            <ion-label class="flex-align-center flex text-base font-bold normal-case">
                <ion-icon class="vl-app-light:hidden mr-2 h-8 w-8" name="add-outline"></ion-icon>
                <img
                    class="vl-app-light:block text-bold mr-4 hidden"
                    [src]="(assetsPath$ | async) + '/img/add-buy-ticket.svg'"
                    alt="" />
                {{ 'BTN_BUY_TICKET' | translate }}
            </ion-label>
        </button>
    </div>
</div>
<rwidget-no-internet-alert></rwidget-no-internet-alert>
